export default __webpack_public_path__ + "static/media/apple-touch-icon.e8e8aae1.png";